import styled, {css} from 'styled-components';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import {device} from '../../../styles/media';
import colors from '../../../styles/colors';


export const StyledContainer = styled(Container)`
    height: auto:
    max-height: 700px;
    padding-left: 6.0rem;
    padding-right: 6.0rem; 
`
export const StyledGrid = styled(Grid)`
    text-align: center;
    height: auto;
`
export const StyledGridItem = styled(Grid)`
    height: auto;
    ${props => props.image && css`
        @media ${device.tablet}{
            display: none;
        }
    `}
`
export const StyledH2 = styled.h2`
    font-size: 3rem;
    font-weight: 400;
    padding-top: 6rem;

    @media ${device.tablet}{
        padding-top: 0;
        margin-bottom: 0;
    }
`
export const StyledImg = styled.img`
    width: auto;
    max-width: 600px;
    padding-top: 2rem;
`
export const StyledIcon = styled(FontAwesomeIcon)`
    color: ${colors.secondary};
    font-size: 1.5rem;
    padding-right: 0.5rem;
`
export const StyledP = styled.p`
    text-align: left;
    padding: 0.5rem;
    display: inline-flex;
    vertical-align: middle;
    margin-bottom: 0;
`
export const StyledSpan = styled.span`
    color: ${colors.secondary};
`